/**
 * Define default results so every type has at least 0 items by default.
 * @type {{product: Array, reference: Array, topic: Array, download: Array}}
 */
const defaultResults = {
    product: [],
    reference: [],
    topic: [],
    download: [],
};

/**
 * Transforms a collection of search result elements
 * into primitive data, grouped by rseult type.
 * @param {Element[]} elements
 * @returns {Object}
 */
const transformSearchResults = (elements) => (
    elements
        .map(element => ({ ...element.dataset }))
        .reduce((acc, item) => ({
            ...acc,
            [item.type]: Array.isArray(acc[item.type])
                ? acc[item.type].concat(item)
                : [item],
        }), defaultResults)
);

export default transformSearchResults;



// WEBPACK FOOTER //
// ./src/scripts/components/search/transformSearchResults.js